// Account/service restrictions outlive ordinary task reads and local UI resets.
// Only an authoritative availability response may release them; balances alone
// do not prove enough budget for a request.
const availabilityCodes = [
  'USER_QUOTA_INSUFFICIENT', 'QUOTA_EXHAUSTED', 'FAMILY_QUOTA_EXHAUSTED',
  'PLATFORM_BUDGET_EXHAUSTED', 'AI_DISABLED', 'AI_ROLE_DISABLED',
  'AI_SERVICE_UNAVAILABLE', 'AI_CONFIGURATION_REQUIRED', 'AI_PLATFORM_POLICY_UNAVAILABLE', 'PROMPT_UNAVAILABLE'
];
export function availabilityError(code) { return availabilityCodes.includes(code); }
export function availabilityRestriction(value) {
  if (!value || typeof value.available !== 'boolean') throw new Error('WRONG_RESPONSE');
  return value.available ? null : value;
}
export function composerError(page) {
  return !page.initialBlock && page.availabilityBlock && page.availabilityBlock.message || page.error || '';
}
export function errorActions(page) {
  return [{ id: 'retry', label: !page.availabilityBlock && page.pendingRequest ? '重试原请求' : '刷新重试' },
    ...(!page.availabilityBlock && page.canEnterConversation ? [{ id: 'newConversation', label: '新建对话' }] : [])];
}
